import { useSelector } from 'react-redux';
import authSlice from '../store/auth/slice';

export const useLoggedUser = () => {
  const loggedUser = useSelector<any, any>(
    (state) => state[authSlice.name].user,
  );
  return { loggedUser };
};
